import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../enterprise.service";
import { Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-branch-requests",
  templateUrl: "./branch-requests.component.html",
  styleUrls: ["./branch-requests.component.sass"],
})
export class BranchRequestsComponent implements OnInit {
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private enterpriseService: EnterpriseService,
    private router: Router,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {}

  page: number = 0;
  itemsPerPage: number = 5;
  totalItems: number = 0;

  selectedTab: number = 1;

  enterpriseBranchRequests: any[] = [];
  selectedBranch: any;
  // ---------- Change Tab ----------
  changeTab(tab: number) {
    this.selectedTab = tab;
    this.page = 0; // reset page when changing tabs
    this.getAllBranchRequests();
  }

  // ---------- Get Requests ----------
  getAllBranchRequests() {
    this.spinner.show();

    let data = {
      page: this.page,
      limit: this.itemsPerPage,
    };

    this.enterpriseService.getEntpBranchRequests(data).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode == 200) {
          this.enterpriseBranchRequests = result.data;
          this.totalItems = result.pagination?.total;
        } else {
          this.toastr.error(result.message);
          this.enterpriseBranchRequests = [];
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  // ---------- Pagination ----------
  gty(page) {
    this.page = page;
    this.getAllBranchRequests();
  }

  updateRequest(id: any, status: number) {
    this.spinner.show();
    let data = {
      status: status,
    };
    this.enterpriseService.approveRejectEntpBranchRequest(id, data).subscribe(
      (result: any) => {
        this.spinner.hide();

        if (result.statusCode == 200) {
          this.toastr.success(result.message);
          this.spinner.hide();
          this.getAllBranchRequests();
        } else {
          this.toastr.error(result.message);
          this.enterpriseBranchRequests = [];
          this.spinner.hide();
        }
      },
      (err) => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  openViewModal(content: any, data: any) {
    this.selectedBranch = data;
    this.modalService.open(content, {});
  }
}
